module.exports = __webpack_public_path__ + "static/media/FuturaLTBook.2beee158.ttf";